export const initialState = {
  structure: null,
  // structure example data
  // {
  //   skincare: [
  //     {
  //       name: str,
  //       root: str,
  //       pageTitle: str,
  //       url: str,
  //       groupedProducts: bool,
  //       productsQuery: {
  //         groups: array, // types
  //         productsFeed: str,
  //         gender: str,
  //       },
  //       brandsQuery: {
  //         groups: str,
  //         gender: str,
  //       },
  //       seo: {
  //         title: str,
  //         description: str,
  //       },
  //       analytics: {
  //         page: str,
  //         placement: str,
  //       },
  //       children: array, // Duplicates the current data structure (recursively)
  //     },
  //   ],
  // },
  notEmptyTypes: {
    makeup: [],
    skincare: [],
    wellness: [],
    personalCare: [],
  },
}

export const setNotEmptyTypes = (state, payload) => (
  { ...state, notEmptyTypes: payload }
)

export const setStructure = (state, payload) => (
  { ...state, structure: payload }
)
